import React from "react";
import { Trash2, Pencil } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { iconBtnClass } from "@/components/Brand";

/** Existing presets with edit / remove actions. */
export const TemplateList = ({ templates, onEdit, onRemove }) => {
  const { t } = useI18n();

  if (templates.length === 0) return null;

  return (
    <div className="space-y-3" data-testid="template-list">
      {templates.map((tpl) => (
        <div key={tpl.template_id} className="flex flex-wrap items-center justify-between gap-3 border-b border-[#1E1E1E] pb-3">
          <div>
            <p className="text-sm">{tpl.name}</p>
            <p className="text-[11px] text-[#707070] font-mono-accent">
              {tpl.edit_quota} {t("edits")}
              {(tpl.print_quota_items || []).map((i) => ` · ${i.qty}× ${i.size}`).join("")}
            </p>
          </div>
          <span className="flex items-center gap-4">
            <button data-testid={`edit-template-${tpl.template_id}`} onClick={() => onEdit(tpl)}
              className={`${iconBtnClass} text-[#5A5A5A] hover:text-[#D4AF37]`} aria-label={t("edit")}>
              <Pencil size={14} />
            </button>
            <button data-testid={`remove-template-${tpl.template_id}`} onClick={() => onRemove(tpl.template_id)}
              className={`${iconBtnClass} text-[#5A5A5A] hover:text-[#8B0000]`} aria-label={t("remove")}>
              <Trash2 size={14} />
            </button>
          </span>
        </div>
      ))}
    </div>
  );
};
